
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"51.671","height":"47.018"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.825.003a2.708 2.708 0 00-2.2 1.274L21.156 40.241 4.655 25.982a2.708 2.708 0 10-3.554 4.062l18.87 16.333a2.7 2.7 0 004.02-.592l27.207-41.55A2.707 2.707 0 0048.825.003z","fill":"#fcffff"}})])
          )
        }
      }
    